const gameCards = document.querySelectorAll('.our-games__card')
const gameVideos = document.querySelectorAll('.our-games__video')
const videoPopup = document.querySelector('.video__popup')
const videoPopupVideo = videoPopup?.querySelector('.video__popup-video video')
const videoPopupClose = videoPopup?.querySelector('.video__popup-close')
const videoContainer = document.querySelector('.our-games__videos')

const handleClosePopup = () => {
	videoPopup.classList.remove('active')
	document.body.classList.remove('scroll-lock')
	videoPopupClose.classList.remove('active')
	videoPopupVideo.pause()
}

const performActionBasedOnWidth = () => {
	const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

	if (screenWidth <= 992 && videoPopup) {
		gameVideos.forEach((video) => {
			video.classList.remove('active')
		})

		videoPopupClose.addEventListener('click', handleClosePopup)

		gameCards.forEach((card, i) => {
			card.classList.remove('active')

			card.addEventListener('click', (e) => {
				if (e.target.closest('a')) {
					return false
				}

				videoPopupVideo.src = gameVideos[i].currentSrc

				document.body.classList.add('scroll-lock')
				videoPopup.classList.add('active')

				videoPopupVideo.addEventListener('loadeddata', () => {
					videoPopupClose.classList.add('active')
				})

				videoPopupVideo.play()
			})
		})
	} else {
		gameCards.forEach((card, i) => {
			card.addEventListener('click', () => {
				gameCards.forEach((card) => {
					card.classList.remove('active')
				})

				card.classList.add('active')

				gameVideos.forEach((video) => {
					video.classList.remove('active')
					video.pause()
					video.currentTime = 0
				})

				gameVideos[i].classList.add('active')

				videoContainer.classList.add('loading')
				gameVideos[i].load()
			})
		})
	}

	document.addEventListener('click', (e) => {
		if (e.target === videoPopup) {
			handleClosePopup()
		}
	})
}

window.addEventListener('load', performActionBasedOnWidth)
window.addEventListener('resize', performActionBasedOnWidth)

document.querySelectorAll('.our-games__video').forEach((video) => {
	video.addEventListener('canplaythrough', (e) => {
		if (e.target.classList.contains('active')) {
			videoContainer.classList.remove('loading')
			e.target.play()
		}
	})
})
